export default __webpack_public_path__ + "static/media/undraw_profile.86b42d1a.svg";